// Кумовство (deus_kumovstvo, cost 2) — oneshot с целью.
// Союзный юнит +1 HP и +2 брони (превышает максимум).
// Реализуется как persistent buff: max-armor +2, current-armor +2, current-hp +1.

import { chargeInfluence } from './influence.js';

export const CARD_ID = 'deus_kumovstvo';
export const COST = 2;

export function canPlayKumovstvo(state, playerIdx) {
  const p = state.players[playerIdx];
  if (p.influence < COST) return { ok: false, reason: 'not_enough_influence' };
  // Нужен хотя бы один свой юнит.
  if (p.unitsOnField().length === 0) return { ok: false, reason: 'no_ally_unit' };
  return { ok: true };
}

// targetCard — союзный юнит.
export function playKumovstvo(state, playerIdx, targetCard) {
  const can = canPlayKumovstvo(state, playerIdx);
  if (!can.ok) return can;
  const p = state.players[playerIdx];
  if (!targetCard || !targetCard.isAlive() || targetCard.ownerId !== p.id || targetCard.type !== 'unit') {
    return { ok: false, reason: 'invalid_target' };
  }
  if (!chargeInfluence(state, playerIdx, COST)) return { ok: false, reason: 'not_enough_influence' };
  // +2 брони (постоянная прибавка к max), +1 HP (постоянный, может превысить максимум).
  targetCard.persistentArmor += 2;
  targetCard.persistentMaxArmor += 2;
  targetCard.current.armor += 2;
  targetCard.current.hp += 1;
  state.log.add(`🤝 ${p.name}: Кумовство → ${targetCard.name_ru} +1 HP, +2 брони (HP=${targetCard.hp}, броня=${targetCard.armor})`);
  return { ok: true };
}
